import { render, staticRenderFns } from "./FormProductInfo.vue?vue&type=template&id=14c0cb48&scoped=true"
import script from "./FormProductInfo.vue?vue&type=script&lang=js"
export * from "./FormProductInfo.vue?vue&type=script&lang=js"
import style0 from "./FormProductInfo.vue?vue&type=style&index=0&id=14c0cb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c0cb48",
  null
  
)

export default component.exports